import { CheckCircleOutlined } from '@mui/icons-material'
import { Box, Typography, DialogProps } from '@mui/material'
import React from 'react'
import { Modal } from 'src/ui'

interface ConfirmMfaProps extends DialogProps {
  open: boolean
}

const ConfirmMfa: React.FC<ConfirmMfaProps> = ({ ...props }: ConfirmMfaProps) => {
  return (
    <Modal onClose={props.onClose} {...props} title="2-factor authentication enabled">
      <Box textAlign="center">
        <CheckCircleOutlined color="primary" sx={{ fontSize: '8rem' }} />
        <Typography variant="h6" fontWeight={400} padding="0 16px">
          2-factor authentication enabled successfully. You can use the new 6 digit authentication code to login from
          now on.
        </Typography>
      </Box>
    </Modal>
  )
}

export default ConfirmMfa
